// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"a5283a27","83":"13b1a154","168":"e4b28749","326":"0e9f8c2f","360":"b867a4a5","418":"48a5e94c","433":"26d36020","486":"3b5d1733","613":"8545e27c","719":"30d8784d","753":"c1bc9cae","981":"0e65ef2b","988":"425f46c2"}[chunkId] + ".chunk.js";
};